import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    imports: [],
    styleUrls: ['./loading.component.css']
})
export class LoadingComponent implements OnInit {
  @Input() isVisible=false;

  constructor() { }

  ngOnInit(): void {
  }

}
